import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserSelectorComponent } from './user-selector.component';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { SharedModule } from 'app/shared/shared.module';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { GetCountryNameByCodeModule } from 'app/utils/pipes/get-country-name-by-code/get-country-name-by-code.module';

@NgModule({
  declarations: [UserSelectorComponent],
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatButtonModule,
    MatSelectModule,
    MatInputModule,
    SharedModule,
    GetCountryNameByCodeModule,
  ],
  exports: [UserSelectorComponent],
})
export class UserSelectorModule {}
